import React, { useState, useEffect } from 'react';
import './Footer.css';
import facebookIcon from '../assets/icons8-facebook-50.png';
import instagramIcon from '../assets/icons8-instagram-logo-50.png';
import linkedinIcon from '../assets/icons8-linkedin-50.png';
import { generateWhatsAppUrl } from '../utils/whatsapp';
import { OPEN_COOKIE_SETTINGS_EVENT } from '../utils/cookieConsent';

function Footer() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);

        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <footer className="footer">
                <div className="footer-container">
                    <div className="footer-section">
                        <h3>EVOOMedical.ro</h3>
                        <ul>
                            <li><a href="/termeni-si-conditii">Termeni și condiții</a></li>
                            <li><a href="/conditii-generale">Condiții generale de prestare (extras)</a></li>
                            <li><a href="/politica-de-confidentialitate">Politica de confidențialitate</a></li>
                            <li><a href="/politica-de-cookies">Politica de cookie-uri</a></li>
                            <li><a href="/gdpr">Informații GDPR</a></li>
                            <li><a href="/drepturile-pacientului">Drepturile pacientului</a></li>
                            <li><a href="https://anpc.ro" target="_blank" rel="noopener noreferrer">Protecția consumatorilor</a></li>
                        </ul>
                    </div>
                    <div className="footer-section">
                        <h3>Contact</h3>
                        <ul>
                            <li>
                                Telefon:{' '}
                                <a
                                    href={generateWhatsAppUrl('+40 752 875 121')}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="footer-highlight"
                                    title="Contactează-ne pe WhatsApp"
                                >
                                    +40 752 875 121
                                </a>
                            </li>
                            <li><a href="/contact">Contact</a></li>
                            <li><a href="/cariere">Cariere</a></li>
                            <li><a href="/sesizari">Sesizări și reclamații</a></li>
                            <li><a href="/supraveghere-video">Supraveghere video</a></li>
                            <li><a href="/date-de-identificare">Date de identificare</a></li>
                        </ul>
                        <h4 className="footer-subheading">Social media</h4>
                        <div className="social-links">
                            <a href="https://facebook.com/evoomedical" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                <img src={facebookIcon} alt="Facebook" className="social-icon" />
                            </a>
                            <a href="https://instagram.com/evoomedical" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <img src={instagramIcon} alt="Instagram" className="social-icon" />
                            </a>
                            <a href="https://linkedin.com/company/evoomedical" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
                            </a>
                        </div>
                    </div>
                    <div className="footer-section">
                        <h3>Locație</h3>
                        <div className="map-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2774.7682828996058!2d23.56194932379877!3d45.93593085596629!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDXCsDU2JzA3LjkiTiAyM8KwMzMnNDIuMiJF!5e0!3m2!1sen!2sro!4v1756840785463!5m2!1sen!2sro"
                                width="100%"
                                height="250"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Evoo Medical Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2026 Evoo Medical. Toate drepturile rezervate.</p>
                    <button
                        type="button"
                        className="footer-cookie-settings"
                        onClick={() => window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT))}
                    >
                        Setări cookie-uri
                    </button>
                </div>
            </footer>
            {isVisible && (
                <button
                    className="back-to-top-fixed visible"
                    onClick={scrollToTop}
                    aria-label="Scroll to top"
                >
                    ↑
                </button>
            )}
        </>
    );
}

export default Footer;
